import footer from "./Footer.module.css";
import { BehanceLogo, LinkedinLogo } from 'phosphor-react';

function Footer() {
    return(
        <main id="footer" className={footer.footer}>
            <div className={footer.content}>
                <div className={footer.description}>
                    <h3 className={footer.h3}>DO YOU HAVE A PROJECT IN MIND?</h3>
                    <h1 className={footer.h1}>LET'S TALK!</h1>
                </div>
                <div className={footer.buttons}>
                    <a className={footer.mail} href="mailto:kiansegantini@gmail.com">EMAIL</a>
                    <div className={footer.socials}>
                        <a className={footer.social} href="https://linkedin.com/in/kian-segantini" target="_blank" rel="noreferrer"><LinkedinLogo weight="light" className={footer.icons} />LINKEDIN</a>
                        <a className={footer.social} href="https://behance.net/kiansegantini" target="_blank" rel="noreferrer"><BehanceLogo weight="light" className={footer.icons} />BEHANCE</a>
                    </div>
                </div>
            </div>
            <p className={footer.copyright}>© 2026 Kian Sega[n]tini. All rights reserved.</p>
        </main>
    );
}

export default Footer;